var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div",on:{"click":_vm.createdCode}},[_c('canvas',{attrs:{"id":"div","width":_vm.contentWidth,"height":_vm.contentHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }